<template>
  <div class="carriers-detail">
    <el-row type="flex"
            :gutter="20">
      <el-col>

      </el-col>
      <el-col></el-col>
      <el-col></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CarriersDetail',
}
</script>
